// **************
// p_cardservico.jsx
// autor: Walcledson de Paula/IA
// data: 12/8/24 / 10:55h
// atualização: 13/8/24 / 13:01h
// atualização: 10/9/24 | 19h11 | campo/variável duracao muda automáticamente de minutos para hora, se o usuário digitar algo maior que 00:60 (hh:mm). 
//              Por exemplo: se digitar: 00:70, será convertido para 01:10 automaticamente;
//              O sistema também envia o token jwt na requisição para melhorar a segurança dos dados via web.
// *************

import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import apiaxios from '../../../../Services/apiaxios.js';
import handleApiError from '../../../../Services/apiErrorHandler.js';
import { decrypt } from '../../../../Services/cryptoUtils.js';
import { AutoLogout } from '../../../../Services/autologout.js';

import './p_cardservico.css';
import CardFotoServico from './p_cardfotoservico.jsx';

const CardServico = ({ id_empresa, operacao, servico, openDock, closeDock }) => {
    // console.log('cardServico Props "operacao" + "servico"', operacao, servico);
    const [id_servico, setId_servico] = useState(0);
    const [descricao, setDescricao] = useState('');
    const [duracao, setDuracao] = useState('');
    const [valor, setValor] = useState('');
    const [vrDesconto, setVrDesconto] = useState('');
    const [vrTotal, setVrTotal] = useState(0);
    const [percentualDesconto, setPercentualDesconto] = useState(0);
    const [loading, setLoading] = useState(false);
    // const [fotoServico, setFotoServico] = useState(null);
    const [fotoGrande, setFotoGrande] = useState(null);
    const [showCardFotoServico, setShowCardFotoServico] = useState(false); // Novo estado
    
    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    const tokenlg = localStorage.getItem("tokenlg");
    useEffect(() => {
        // alert('cardServico Props "operacao"', operacao);
        // const tokenlg = localStorage.getItem("tokenlg");
       
        if (!tokenASW || !tokenlg) {
            AutoLogout();
        }
    }, [tokenASW, tokenlg]);

    useEffect(() => {
        if (operacao === 'edit' && servico) {
            const fetchFotoGrande = async () => {
                // console.log('dentro de fetchFotoGrande');
                try {
                    const response = await apiaxios.get('/servico/fotoWeb', {
                        params: {
                            id_servico: servico.ID_SERVICO,
                            id_usuario: id_empresa,
                            token: tokenASW
                        }
                    });
    
                    // console.log('response :', response);
                    // console.log('response.data :', response.data);
                    // console.log('response.data.result[0].retorno :', response.data.RESULT[0].retorno);
                    // console.log('response.data.result[0].foto :', response.data.RESULT[0].foto);
                    if (response.data && response.data.RESULT && response.data.RESULT[0].retorno === "OK") {
                        if (response.data && response.data.RESULT && response.data.RESULT.length > 0 && response.data.RESULT[0].foto) {
                            setFotoGrande(`data:image/jpeg;base64,${response.data.RESULT[0].foto}`);
                        } else {
                            setFotoGrande(null); // Ou uma imagem padrão
                            // if (response.data && response.data.RESULT && response.data.RESULT.length > 0 && response.data.RESULT[0].retorno) {
                            //     console.error("Erro ao carregar foto grande:", response.data.RESULT[0].retorno);
                            // } else {
                            //     console.error("Erro ao carregar foto grande: Resposta do servidor sem dados de foto.");
                            // }
                        }
                    }
                } catch (error) {
                    console.error("Erro ao carregar foto grande:", error);
                    setFotoGrande(null);
                    handleApiError(error);
                }
            };

            fetchFotoGrande(); // Chama a função para carregar a foto grande
            setId_servico(servico.ID_SERVICO);
            // setFotoServico(`data:image/jpeg;base64,${servico.SER_Foto}`);
            setDescricao(servico.DESCRICAO);
            setDuracao(servico.DURACAO);
            setValor(servico.VALOR * 100);
            setVrDesconto(servico.VR_DESCONTO * 100);
            setVrTotal(servico.VR_TOTAL * 100);
            setPercentualDesconto((servico.VR_DESCONTO / servico.VR_TOTAL) * 100);

        } else {
            setFotoGrande(null); // Limpa a foto grande quando o Dock fecha ou a operação não é 'edit'
            // setFotoServico('');
            setDescricao('');
            setDuracao('');
            setValor(0);
            setVrDesconto(0);
            setVrTotal(0);
            setPercentualDesconto(0);
        }
    // }, [operacao, servico]);
    }, [operacao, servico, id_empresa, tokenASW]);

    const handleSubmit = () => {
        // Lógica de submissão
    };

    // Função para formatar o valor em moeda
    const formatCurrency = (value) => {
        if (typeof value !== 'string') {
            value = String(value); // Converte o valor para string se não for
        }

        const numericValue = value.replace(/\D/g, ''); // Remove tudo que não for número
        const formattedValue = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
        }).format(parseFloat(numericValue) / 100); // Divide por 100 para adicionar as casas decimais
        return formattedValue;
    };

    // Função para salvar os dados (alterados ou novos)
    const handleSalvarDados = () => {
        setShowCardFotoServico(false);
        if (validateForm()) {            
            if (operacao === 'add') {
                closeDock();
                Swal.fire({
                    title: 'Confirmação',
                    text: 'Confirma os dados do novo Serviço ?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, salvar!',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        fetchSalvarDados();
                    }
                    openDock();
                });
            } else {
                closeDock();
                Swal.fire({
                    title: 'Confirmação',
                    text: "Confirma a alteração dos dados do Serviço " + id_servico + ' ?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, alterar!',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        fetchSalvarDados();
                    }
                    openDock();
                });
        
            }
        }
    };

    const fetchSalvarDados = async () => {
        setLoading(true);
        if (operacao === 'add') {
            // Formata a duração para o formato esperado pelo servidor
            const formattedDuracao = formatForServer(duracao);
            try {
                // console.log('id_usuario ', id_empresa);
                // console.log('token ', tokenASW);
                const response = await apiaxios.post('servico/crudWeb', 
                    {
                        id_empresa,
                        // foto: fotoServico,
                        foto: fotoGrande,
                        descricao,
                        duracao: formattedDuracao,
                        valor: parseCurrency(valor / 100),
                        vr_desconto: parseCurrency(vrDesconto / 100),
                        vr_total : parseCurrency(vrTotal / 100)
                    },
                    {
                        params: {
                            'id_usuario': id_empresa,  // Enviando id_usuario no cabeçalho
                            'token': tokenASW  // Enviando token JWT no cabeçalho
                        }
                    }
                );

                if (response.status === 201) {
                    const data = response.data;
                    if (data.retorno === 'OK') {
                        Swal.fire('Informação', 'Serviço Cadastro com sucesso!', 'success');
                        closeDock();
                    } else {
                        Swal.fire('Erro', data.retorno, 'error');
                        openDock();
                    }
                } else { if (response.status !== 201) {
                    const data = response.data;
                    Swal.fire('Erro', data.retorno, 'error');
                    } else {
                        Swal.fire('Erro', 'Falha ao salvar dados do serviço. Tente novamente mais tarde.', 'error');
                        openDock();
                    }
                }
            } catch (error) {
                handleApiError(error);
            } finally {
                setLoading(false);
            }
        } else {
            try {
                const response = await apiaxios.put('/servico/crudWeb', 
                    {
                        id_servico,
                        id_empresa,
                        // foto: fotoServico,
                        foto: fotoGrande,
                        descricao,
                        duracao,
                        valor: parseCurrency(valor / 100),
                        vr_desconto: parseCurrency(vrDesconto / 100),
                        vr_total : parseCurrency(vrTotal / 100)
                    },
                    {
                        params: {
                            'id_usuario': id_empresa,  // Enviando id_usuario no cabeçalho
                            'token': tokenASW  // Enviando token JWT no cabeçalho
                        }
                    }
                );
                if (response.status === 200) {
                    const data = response.data;
                    if (data.retorno === 'OK') {
                        Swal.fire('Informação', 'Serviço alterado com sucesso!', 'success');
                        closeDock();
                    } else {
                        Swal.fire('Erro', data.retorno, 'error');
                        openDock();
                    }
                } else { if (response.status !== 200) {
                    const data = response.data;
                    Swal.fire('Erro', data.retorno, 'error');
                    } else {
                        Swal.fire('Erro', 'Falha ao tentar salvar alterações do serviço. Tente novamente mais tarde.', 'error');
                        openDock();
                    }
                }
            } catch (error) {
                handleApiError(error);
            } finally {
                setLoading(false);
            }
        }
    };    

    const formatForServer = (value) => {
        // Remove caracteres não numéricos e formata a entrada
        let formattedValue = handleTimeInput(value);
    
        // Divide a string em horas e minutos
        const [hoursStr, minutesStr] = formattedValue.split(':');
        let hours = parseInt(hoursStr, 10) || 0;
        let minutes = parseInt(minutesStr, 10) || 0;
    
        // Converte para minutos totais e depois ajusta
        let totalMinutes = (hours * 60) + minutes;
    
        // Ajusta para horas e minutos novamente
        const adjustedHours = Math.floor(totalMinutes / 60);
        const adjustedMinutes = totalMinutes % 60;
    
        return `${String(adjustedHours).padStart(2, '0')}:${String(adjustedMinutes).padStart(2, '0')}`;
    };
    
    // Função para aplicar máscara de HH:MM
    const handleTimeInput = (value) => {
        value = value.replace(/\D/g, ''); // Remove caracteres não numéricos
        if (value.length > 4) {
            value = value.substring(0, 4); // Limita a 4 caracteres numéricos
        }
        value = value.replace(/(\d)(\d{2})$/, '$1:$2'); // Adiciona a vírgula antes dos últimos dois dígitos
        // value = value.replace(/(?=(\d{2})+(\D))\B/g, ':'); // Adiciona pontos a cada milhar
        return value;
    };

    // Função para remover formatação antes de enviar ao servidor
    const parseCurrency = (value) => {
        if (typeof value !== 'string') {
            // Se não for string, converter para string
            value = String(value);
        }
    
        // Remover pontos e converter vírgula para ponto
        return parseFloat(value.replace(/\./g, '').replace(',', '.'));
    };

    // Função para ajustar a formatação do campo valor total
    const handleValorChange = (value) => {
        const numericValue = parseFloat(value.replace(/[^\d.-]/g, '')) || 0;
        setValor(numericValue);
        setVrTotal(numericValue - vrDesconto);
        setPercentualDesconto((vrDesconto / numericValue) * 100);
    };
    
    // Função para ajustar a formatação do campo % desconto
    const handleVrDescontoChange = (value) => {
        const numericValue = parseFloat(value.replace(/[^\d.-]/g, '')) || 0;
        setVrDesconto(numericValue);
        setVrTotal(valor - numericValue);
        setPercentualDesconto((numericValue / valor) * 100);
    };

    const validateForm = () => {
        if (!descricao || descricao.trim() === '') {
            closeDock();
            Swal.fire({
                title: 'Atenção',
                text: 'O campo "Descrição" é obrigatório!',
                icon: 'error',
            }).then((result) => {
                if (result.isConfirmed) {
                    openDock();
                }
            });
            return false;
        }
        
        if (!duracao || duracao.trim() === '') {
            closeDock();
            Swal.fire({
                title: 'Atenção',
                text: 'O campo "Duração" é obrigatório!',
                icon: 'error',
            }).then((result) => {
                if (result.isConfirmed) {
                    openDock();
                }
            });
            return false;
        }
      
        if (!valor || valor <= 0) {
            closeDock();
            Swal.fire({
                title: 'Atenção',
                text: 'O campo "Valor" é obrigatório e deve ser maior que "0" !',
                icon: 'error',
            }).then((result) => {
                if (result.isConfirmed) {
                    openDock();
                }
            });
            return false;
        }
        return true;
    };

    // função para habilitar os botões: câmera e galeria
    const handleFotoChange = (userId) => {
        setShowCardFotoServico(true); // Atualize o estado para mostrar o CardFotoPerfil
    };

    // função para fechar corretamente o Dock
    const handleCloseDock = () => {
        setShowCardFotoServico(false); // Atualize o estado para mostrar o CardFotoPerfil
        closeDock();
    };
      



    return (
        <div className='container-fluid h-100 pt-4 sidebar p-4'>
            {/* ****** título (novo ou editar serviço) ******** */}
            {/* {console.log('dentro de container - id_servico: ', id_servico)} */}
            <h4 className='d-inline'>
                {operacao === 'add' ? 'Adicionar Serviço' : 'Editar Serviço: id #' + id_servico}
            </h4>
            <hr />
            {/* <br /> */}
            {/* {alert('operacao', operacao)} */}
            {operacao === 'edit' && 
                <div className="cardservico-info">
                    {/* {console.log('operacao', operacao)}
                    {console.log('fotoGrande', fotoGrande)} */}
                    <div className="img-cardservico text-center">
                        {/* <img src={fotoServico} className="servico-foto" alt="foto serviço indisponível" /> */}
                        {fotoGrande ? 
                            <div>
                                <img src={fotoGrande} className="cardservico-foto" alt="foto serviço indisponível" />
                                <button type="button" className="btn btn-primary btn-sm ml-10" onClick={() => handleFotoChange(id_servico)}>Alterar Foto</button>
                            </div>
                            : 
                            <div>
                                <br />
                                <h4>Foto indisponível</h4>
                                <button type="button" className="btn btn-primary btn-sm ml-10" onClick={() => handleFotoChange(id_servico)}>Incluir Foto</button>
                            </div>
                        }
                        {/* <button type="button" className="btn btn-primary btn-sm ml-10" onClick={() => handleFotoChange(id_servico)}>Alterar Foto</button> */}
                        {showCardFotoServico && (
                            <div className="col-lg-3 ml-10 col-md-4 col-sm-12">
                                <CardFotoServico userId={id_empresa} servicoId={id_servico} openDock={openDock} closeDock={closeDock} />
                            </div>
                        )}
                    </div>
                </div>
            }

            <form onSubmit={handleSubmit}>
                {/* ****** campos do serviço ******** */}
                <div className='row tela-card'>
                    <div className='col-12 mt-4'>
                        <p className='text-secundary'>Descrição</p>
                        <div className='form-contrl mb-2'>
                            {/* <input value={operacao === 'edit' ? servico.DESCRICAO : ''} type="text" className='form-control' */}
                            <input type="text" className='form-control'
                                value={descricao}
                                onChange={(e) => setDescricao(e.target.value.toUpperCase())}  
                            />
                        </div>
                    </div>
                    <div className='col-12 mt-4'>
                        <p className='text-secundary'>Duração(hh:mm)</p>
                        <div className='form-contrl mb-2'>
                            <input className='form-control'
                                id="timeInput"
                                type="text"
                                value={duracao}
                                onChange={(e) => setDuracao(handleTimeInput(e.target.value))}
                                maxLength={5} // Para garantir que não exceda 'hh:mm'
                            />
                        </div>
                    </div>

                    <div className='col-12 mt-4'>
                        <p className='text-secundary'>Valor</p>
                        <div className='form-contrl mb-2'>
                            <input type="text" className='form-control'
                                value={formatCurrency(valor)}
                                onChange={(e) => handleValorChange(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='col-12 mt-4'>
                        <p className='text-secundary'>Vr Desconto</p>
                        <div className='form-contrl mb-2'>
                            <input type="text" className='form-control'
                                value={formatCurrency(vrDesconto)}
                                onChange={(e) => handleVrDescontoChange(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='col-12 mt-4'>
                        <p className='text-secundary'>Vr Total</p>
                        <div className='form-contrl mb-2'>
                            <input disabled value={formatCurrency(vrTotal)} type="text" className='form-control'/>
                        </div>
                    </div>
                    <div className='col-12 mt-4'>
                        <p className='text-secundary'>% Desconto</p>
                        <div className='form-contrl mb-2'>
                            <input disabled value={percentualDesconto.toFixed(2) + '%'} type="text" className='form-control'/>
                        </div>
                    </div>
                </div>            
            </form>

            {/* ****** botões salvar/cancelar ******** */}
            <div className='rwo align-items-end footer'>
                <div className='text-center'>
                    <button className='btn btn-outline-primary me-3'
                        // onClick={closeDock}>Cancelar
                        onClick={handleCloseDock}>Cancelar
                    </button>
                    <button type='submit' className='btn btn-primary'
                        onClick={handleSalvarDados}
                    >
                        {operacao === 'add' ? 'Adicionar' : 'Salvar Alterações'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CardServico;